import { useForm } from "react-hook-form";
import DirectoryPickerInput from "../../../shared/form/fields/DirectoryPickerInput.tsx";
import FormActions from "../../../shared/form/fields/FormActions.tsx";
import { fetchApi } from "../../../../helpers/reactQueryApi.ts";
import { useMutation } from "react-query";
import Modal from "../../../shared/Modal.tsx";
import { useUpdateActivityInCache } from "../../../../hooks/activitystreams/useUpdateActivityInCache.ts";
import PleaseWaitAlert from "../../../shared/PleaseWaitAlert.tsx";

type FormData = {
  new_actor: { id: string };
};

type ChangeAuthorFormArgs = {
  activityId: string;
  close: () => void;
};

export default function ChangeAuthorForm({
  activityId,
  close,
}: ChangeAuthorFormArgs) {
  const { updateActivity } = useUpdateActivityInCache();
  const { handleSubmit, control } = useForm<FormData>();

  const { mutate: changeAuthor, isLoading } = useMutation(
    (body: { new_actor_id: string }) =>
      fetchApi(`/activities/${activityId}`, { method: "PATCH", body }),
    {
      onSuccess: (data) => {
        toastr.success(I18n.t("js.saving_successful"));
        close();
        updateActivity(activityId, (activity) => ({
          ...activity,
          actor: data.actor,
        }));
      },
      onError: () => toastr.error(I18n.t("js.generic_error")),
    },
  );

  function submit({ new_actor }: FormData) {
    changeAuthor({ new_actor_id: new_actor.id });
  }

  return (
    <Modal
      title={I18n.t("js.activitystreams.change_author.title")}
      onClose={close}
    >
      <form onSubmit={handleSubmit(submit)}>
        <div className="modal-body">
          <div className="alert alert-warning">
            {I18n.t("js.activitystreams.change_author.warning")}
          </div>
          <DirectoryPickerInput
            control={control}
            name="new_actor"
            endpoint="/directory/members"
            multi={false}
            required
          />
          {isLoading && <PleaseWaitAlert />}
        </div>
        <div className="modal-footer">
          <FormActions onCancel={close} saveDisabled={isLoading} />
        </div>
      </form>
    </Modal>
  );
}
